export default "__VITE_PUBLIC_ASSET__f8d18ae6__"